import { Breadcrumb } from '@/components/Atoms/Breadcrumbs'
import { Navigate, Outlet } from 'react-router'
import { Card, CardContent } from '@/components/ui/card'
import { buildPath } from '@/routes'
import { HasFeature } from '@/components/Atoms/Permissions'
import { TicketsFeature } from '@/lib/features'

export function TicketsLayout() {
  return (
    <HasFeature
      feature={TicketsFeature}
      noFeatureComponent={<Navigate to={buildPath('/')} />}
    >
      <Breadcrumb label="Tickets" path={buildPath('/tickets')} />
      <Card>
        <CardContent className="flex flex-col gap-4 lg:min-h-[500px]">
          <Outlet />
        </CardContent>
      </Card>
    </HasFeature>
  )
}
